export enum Source {
  'ALL' = 'ALL_USERS',
  'ALL_WITH_POSITIONING' = 'ALL_USERS_WITH_POSITION',
  'CSV' = 'CSV',
  'POLL' = 'POLL',
}

export type PollAudience = 'PARTICIPANTS' | 'WINNERS';
export type WinnerPick = 'RANDOM' | 'EARLIEST';

/** How a segment with source `POLL` was picked from a poll or quiz. */
export type SegmentPoll = {
  pollId: string;
  pollType: string;
  audience: PollAudience;
  limit?: number;
  pick?: WinnerPick;
  /** Number of users in the audience before `limit` was applied. */
  qualifiedCount: number;
};

export type CreateSegmentFromPollBody = {
  pollId: string;
  name?: string;
  description?: string;
  audience: PollAudience;
  limit?: number;
  pick?: WinnerPick;
};

export type CreateSegmentFromPollResponse = {
  message: string;
  id: string;
  idsCount: number;
  qualifiedCount: number;
};
export type SegmentDB = {
  id?: string;
  segmentId?: string;
  name: string;
  description: string;
  source?: Source;
  createdAt?: string;
  idsCount?: number;
  type: 'SEGMENT' | 'TOPIC';
  contentType?: 'NEWS' | 'EVENTS' | 'FOTBOLLPLAY';
  poll?: SegmentPoll;
};
export type Segment = {
  id: string;
  segmentId?: string;
  name: string;
  description: string;
  source?: Source;
  createdAt?: string;
  idsCount?: number;
  type: 'SEGMENT' | 'TOPIC';
  contentType?: 'NEWS' | 'EVENTS' | 'FOTBOLLPLAY';
  poll?: SegmentPoll;
};
